'use client';
import React from 'react';
import Link from 'next/link';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { useLanguage } from '@/lib/LanguageContext';
import { getTranslations } from '@/lib/i18n';

// metadata removed - client component

const results = [
  { value: '35%', labelEs: 'Reducción de costos operativos TI', labelFr: 'Réduction des coûts opérationnels IT' },
  { value: '18 meses', labelEs: 'Hoja de ruta estratégica definida', labelFr: 'Feuille de route stratégique définie' },
  { value: '+12', labelEs: 'Procesos digitalizados', labelFr: 'Processus numérisés' },
  { value: '6', labelEs: 'Áreas de negocio impactadas', labelFr: 'Domaines d\'activité impactés' },
];


const sectors = [
  { icon: 'fas fa-hospital', labelEs: 'Salud', labelFr: 'Santé' },
  { icon: 'fas fa-university', labelEs: 'Educación', labelFr: 'Éducation' },
  { icon: 'fas fa-building', labelEs: 'Gobierno', labelFr: 'Gouvernement' },
  { icon: 'fas fa-industry', labelEs: 'Industria', labelFr: 'Industrie' },
  { icon: 'fas fa-store', labelEs: 'Retail', labelFr: 'Commerce' },
  { icon: 'fas fa-leaf', labelEs: 'Sustentabilidad', labelFr: 'Durabilité' },
];


const capabilities = [
  { icon: 'fas fa-search', titleEs: 'Diagnóstico Digital', titleFr: 'Diagnostic Numérique', descriptionEs: 'Evaluamos el estado actual de la organización para identificar brechas tecnológicas, ineficiencias operativas y oportunidades de mejora con metodologías probadas.', descriptionFr: 'Nous évaluons l\'état actuel de l\'organisation pour identifier les lacunes technologiques, les inefficacités opérationnelles et les opportunités d\'amélioration.' },
  { icon: 'fas fa-route', titleEs: 'Hoja de Ruta Tecnológica', titleFr: 'Feuille de Route Technologique', descriptionEs: 'Diseñamos un plan estratégico personalizado con etapas claras, prioridades definidas y métricas de éxito para guiar la transformación digital paso a paso.', descriptionFr: 'Nous concevons un plan stratégique personnalisé avec des étapes claires, des priorités définies et des métriques de succès pour guider la transformation numérique.' },
  { icon: 'fas fa-cogs', titleEs: 'Implementación Guiada', titleFr: 'Implémentation Guidée', descriptionEs: 'Acompañamos cada fase de implementación con expertos dedicados, asegurando que cada solución se integre correctamente a los procesos existentes.', descriptionFr: 'Nous accompagnons chaque phase d\'implémentation avec des experts dédiés, en veillant à ce que chaque solution s\'intègre correctement aux processus existants.' },
  { icon: 'fas fa-chart-line', titleEs: 'Gestión del Cambio', titleFr: 'Gestion du Changement', descriptionEs: 'Facilitamos la adopción tecnológica dentro del equipo con estrategias de comunicación, capacitación y seguimiento continuo.', descriptionFr: 'Nous facilitons l\'adoption technologique au sein de l\'équipe avec des stratégies de communication, de formation et de suivi continu.' },
  { icon: 'fas fa-shield-alt', titleEs: 'Cumplimiento Normativo', titleFr: 'Conformité Réglementaire', descriptionEs: 'Asesoramos en el cumplimiento de regulaciones sectoriales, marcos de gobernanza TI y estándares internacionales aplicables a la industria.', descriptionFr: 'Nous conseillons sur la conformité aux réglementations sectorielles, aux cadres de gouvernance IT et aux normes internationales applicables.' },
  { icon: 'fas fa-handshake', titleEs: 'Alianza Estratégica', titleFr: 'Alliance Stratégique', descriptionEs: 'Nos convertimos en el socio tecnológico de largo plazo, con revisiones periódicas y ajustes continuos para mantener la competitividad de la organización.', descriptionFr: 'Nous devenons le partenaire technologique à long terme, avec des révisions périodiques et des ajustements continus pour maintenir la compétitivité de l\'organisation.' },
];


export default function PortfolioAsesoriaConsultoriaPage() {
  const { language } = useLanguage();
  const t = getTranslations(language);
  const p = t.portfolio;
  const isFr = language === 'fr';

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Nunito Sans', 'Raleway', arial, sans-serif" }}>
      <Navbar />
      {/* Hero */}
      <section
        className="relative overflow-hidden"
        style={{ paddingTop: '160px', paddingBottom: '80px', backgroundColor: '#0a0a0a' }}>
        
        <div className="absolute top-20 right-10 opacity-20 hidden lg:block">
          <img src="https://innobox.cl/wp-content/uploads/2021/07/Dots-4.svg" alt="" className="w-40 h-40" />
        </div>
        <div className="absolute bottom-0 left-0 opacity-10 hidden lg:block">
          <img src="https://innobox.cl/wp-content/uploads/2021/07/Abstract-Circle.svg" alt="" className="w-64 h-64" />
        </div>

        <div className="max-w-[1200px] mx-auto px-[35px] relative z-10">
          <nav className="mb-8 flex items-center gap-2 text-sm" style={{ color: '#888' }}>
            <Link href="/" className="hover:text-[#1AEF0F] transition-colors">{p.breadcrumbHome}</Link>
            <span>/</span>
            <Link href="/#portfolio" className="hover:text-[#1AEF0F] transition-colors">{p.breadcrumbPortfolio}</Link>
            <span>/</span>
            <span style={{ color: '#1AEF0F' }}>{isFr ? 'Conseil et Consulting IT' : 'Asesoría y Consultoría TI'}</span>
          </nav>

          <div className="flex flex-col lg:flex-row items-start gap-12">
            <div className="flex-1">
              <div
                className="inline-flex items-center gap-2 mb-6 px-4 py-2"
                style={{ border: '1px solid #1AEF0F', color: '#1AEF0F', fontSize: '13px', letterSpacing: '2px' }}>
                
                <i className="fas fa-drafting-compass" />
                <span>{isFr ? 'CAS D\'ÉTUDE' : 'CASO DE ESTUDIO'}</span>
              </div>
              <h1
                className="text-white font-bold mb-6"
                style={{
                  fontSize: 'clamp(32px, 4vw, 56px)',
                  fontFamily: "'Titillium Web', sans-serif",
                  lineHeight: '1.15'
                }}>
                
                {isFr ? 'Conseil et' : 'Asesoría y'}<br />
                <span style={{ color: '#1AEF0F' }}>{isFr ? 'Consulting IT' : 'Consultoría TI'}</span>
              </h1>
              <p className="mb-8" style={{ fontSize: '18px', color: '#aaa', lineHeight: '1.7', maxWidth: '560px' }}>
                {isFr ? 'Transformation numérique complète d\'un organisme public, atteignant 35% de réduction des coûts IT et la numérisation de 12 processus clés.' : 'Transformación digital completa de un organismo público, logrando 35% de reducción en costos TI y digitalización de 12 procesos clave.'}
              </p>
              <div className="flex flex-wrap gap-4">
                <a
                  href="https://calendar.app.google/qrMMuz1WHJJ4eoab8"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group relative inline-flex items-center overflow-hidden"
                  style={{
                    border: '1px solid #1AEF0F',
                    padding: '14px 32px',
                    fontSize: '15px',
                    fontWeight: 'bold',
                    color: '#1AEF0F',
                    backgroundColor: 'transparent',
                    transition: 'all 300ms ease-out'
                  }}>
                  
                  <span className="relative z-10 transition-colors duration-300 group-hover:text-black">{isFr ? 'Projet Similaire' : 'Proyecto Similar'}</span>
                  <span
                    className="absolute inset-0 transform translate-x-full group-hover:translate-x-0 transition-transform duration-300"
                    style={{ backgroundColor: '#1AEF0F', zIndex: 0 }} />
                  
                </a>
                <Link
                  href="/#portfolio"
                  className="inline-flex items-center gap-2 text-white hover:text-[#1AEF0F] transition-colors"
                  style={{ fontSize: '15px', padding: '14px 0' }}>
                  
                  <i className="fas fa-arrow-left text-sm" />
                  {isFr ? 'Voir tout le portfolio' : 'Ver todo el portfolio'}
                </Link>
              </div>
            </div>

            {/* Stats */}
            <div className="lg:w-72 grid grid-cols-2 gap-4">
              {results?.map((stat, i) =>
              <div key={i} className="p-5" style={{ border: '1px solid #222', backgroundColor: '#111' }}>
                  <div className="font-bold mb-1" style={{ fontSize: '28px', color: '#1AEF0F', fontFamily: "'Titillium Web', sans-serif" }}>
                    {stat?.value}
                  </div>
                  <div style={{ fontSize: '12px', color: '#888', lineHeight: '1.4' }}>{isFr ? stat.labelFr : stat.labelEs}</div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
      {/* Project Image */}
      <section style={{ backgroundColor: '#111' }}>
        <div className="max-w-[1200px] mx-auto px-[35px]">
          <img
            src="https://img.rocket.new/generatedImages/rocket_gen_img_1b04b6ed9-1782331296040.png"
            alt="Asesoría y Consultoría TI - planificación estratégica digital por Innobox"
            className="w-full"
            style={{ display: 'block', maxHeight: '480px', objectFit: 'cover' }} />
          
        </div>
      </section>
      {/* Project Overview */}
      <section style={{ paddingTop: '80px', paddingBottom: '80px', backgroundColor: '#fff' }}>
        <div className="max-w-[1200px] mx-auto px-[35px]">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
            <div>
              <h2 className="font-bold text-black mb-6" style={{ fontSize: 'clamp(24px, 2.5vw, 36px)', fontFamily: "'Titillium Web', sans-serif" }}>
                Descripción del Proyecto
              </h2>
              <p style={{ fontSize: '16px', color: '#505050', lineHeight: '1.8', marginBottom: '20px' }}>
                Proyecto de consultoría estratégica para una organización del sector educativo que buscaba modernizar 
                sus procesos internos y reducir la dependencia de sistemas legacy. El trabajo incluyó un diagnóstico 
                completo, definición de arquitectura objetivo y acompañamiento en la ejecución.
              </p>
              <p style={{ fontSize: '16px', color: '#505050', lineHeight: '1.8' }}>
                El resultado fue una hoja de ruta tecnológica de 18 meses con proyectos priorizados por impacto y 
                viabilidad, logrando una reducción significativa de costos operativos en el primer año.
              </p>
            </div>
            <div>
              <h2 className="font-bold text-black mb-6" style={{ fontSize: 'clamp(24px, 2.5vw, 36px)', fontFamily: "'Titillium Web', sans-serif" }}>
                Alcance y Metodologías
              </h2>
              <div className="space-y-3">
                {['TOGAF Enterprise Architecture', 'ITIL 4 Service Management', 'Análisis de Brecha (Gap Analysis)', 'Gestión de Portafolio de Proyectos', 'Change Management (Prosci ADKAR)', 'Business Process Mapping']?.map((tech, i) =>
                <div key={i} className="flex items-center gap-3">
                    <span style={{ width: '8px', height: '8px', backgroundColor: '#1AEF0F', borderRadius: '50%', flexShrink: 0 }} />
                    <span style={{ fontSize: '15px', color: '#333' }}>{tech}</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Challenge / Solution */}
      <section style={{ paddingTop: '80px', paddingBottom: '80px', backgroundColor: '#f5f5f5' }}>
        <div className="max-w-[1200px] mx-auto px-[35px]">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
            <div className="p-10" style={{ backgroundColor: '#0a0a0a' }}>
              <div className="flex items-center gap-3 mb-6">
                <i className="fas fa-exclamation-triangle text-yellow-400 text-xl" />
                <h3 className="font-bold text-white" style={{ fontSize: '22px', fontFamily: "'Titillium Web', sans-serif" }}>
                  El Desafío
                </h3>
              </div>
              <p style={{ fontSize: '15px', color: '#aaa', lineHeight: '1.8', marginBottom: '16px' }}>
                La organización carecía de una visión tecnológica unificada. Cada área tomaba decisiones de TI de 
                forma independiente, generando duplicidad de sistemas, altos costos de mantenimiento y una experiencia 
                fragmentada para usuarios internos y externos.
              </p>
              <p style={{ fontSize: '15px', color: '#aaa', lineHeight: '1.8' }}>
                La resistencia al cambio y la falta de alineación entre TI y negocio eran los principales obstáculos 
                para avanzar en cualquier iniciativa de transformación digital.
              </p>
            </div>
            <div className="p-10" style={{ backgroundColor: '#1AEF0F' }}>
              <div className="flex items-center gap-3 mb-6">
                <i className="fas fa-check-circle text-black text-xl" />
                <h3 className="font-bold text-black" style={{ fontSize: '22px', fontFamily: "'Titillium Web', sans-serif" }}>
                  La Solución
                </h3>
              </div>
              <p style={{ fontSize: '15px', color: '#0a0a0a', lineHeight: '1.8', marginBottom: '16px' }}>
                Realizamos talleres de alineación estratégica con la dirección y líderes de área para construir 
                una visión compartida. Luego desarrollamos la arquitectura empresarial objetivo y priorizamos 
                iniciativas según impacto, costo y complejidad.
              </p>
              <p style={{ fontSize: '15px', color: '#0a0a0a', lineHeight: '1.8' }}>
                Implementamos un modelo de gobernanza TI con comité de tecnología, métricas de seguimiento y 
                revisiones trimestrales que aseguran la ejecución sostenida de la hoja de ruta.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Capabilities */}
      <section style={{ paddingTop: '80px', paddingBottom: '80px', backgroundColor: '#fff' }}>
        <div className="max-w-[1200px] mx-auto px-[35px]">
          <div className="mb-12">
            <h2 className="font-bold text-black mb-3" style={{ fontSize: 'clamp(24px, 2.5vw, 36px)', fontFamily: "'Titillium Web', sans-serif" }}>
              Capacidades Aplicadas
            </h2>
            <p style={{ fontSize: '16px', color: '#505050', maxWidth: '600px', lineHeight: '1.6' }}>
              Competencias estratégicas y metodológicas que hicieron posible este proyecto de consultoría.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-0">
            {capabilities?.map((cap, i) =>
            <div
              key={i}
              className="group p-8 transition-all duration-300 hover:bg-[#f9f9f9]"
              style={{ borderBottom: '1px solid #E2E2E2', borderRight: i % 3 !== 2 ? '1px solid #E2E2E2' : 'none' }}>
              
                <div className="mb-5 flex items-center justify-center" style={{ width: '52px', height: '52px', border: '1px solid #E2E2E2', borderRadius: '50%' }}>
                  <i className={`${cap?.icon} text-xl text-black group-hover:text-[#1AEF0F] transition-colors duration-300`} />
                </div>
                <h3 className="font-semibold text-black mb-3" style={{ fontSize: '17px', fontFamily: "'Titillium Web', sans-serif" }}>{cap?.title}</h3>
                <p style={{ fontSize: '14px', color: '#505050', lineHeight: '1.6' }}>{cap?.description}</p>
              </div>
            )}
          </div>
        </div>
      </section>
      {/* Sectors */}
      <section style={{ paddingTop: '60px', paddingBottom: '80px', backgroundColor: '#f5f5f5' }}>
        <div className="max-w-[1200px] mx-auto px-[35px]">
          <h2 className="font-bold text-black mb-10" style={{ fontSize: 'clamp(22px, 2vw, 30px)', fontFamily: "'Titillium Web', sans-serif" }}>
            Sectores que Atendemos
          </h2>
          <div className="flex flex-wrap gap-4">
            {sectors?.map((s, i) =>
            <div key={i} className="flex items-center gap-3 px-6 py-4 bg-white" style={{ border: '1px solid #E2E2E2' }}>
                <i className={`${s?.icon} text-[#1AEF0F]`} />
                <span style={{ fontSize: '15px', fontWeight: '600', color: '#111' }}>{s?.label}</span>
              </div>
            )}
          </div>
        </div>
      </section>
      {/* CTA */}
      <section style={{ paddingTop: '70px', paddingBottom: '70px', backgroundColor: '#1AEF0F' }}>
        <div className="max-w-[1200px] mx-auto px-[35px] flex flex-col sm:flex-row items-center justify-between gap-6">
          <p className="text-black font-bold m-0" style={{ fontSize: 'clamp(18px, 2vw, 26px)', fontFamily: "'Titillium Web', sans-serif", lineHeight: '1.3' }}>
            {isFr ? 'Vous voulez des résultats similaires pour votre organisation ?' : '¿Quieres resultados similares para tu organización?'}
          </p>
          <Link href="/contact" className="group relative inline-flex items-center overflow-hidden border border-black text-black bg-transparent flex-shrink-0" style={{ padding: '14px 32px', fontSize: '15px', fontWeight: 'bold', transition: 'all 300ms ease-out' }}>
            <span className="relative z-10 transition-colors duration-300 group-hover:text-white">{p.ctaBtnContact}</span>
            <span className="absolute inset-0 bg-black transform translate-x-full group-hover:translate-x-0 transition-transform duration-300" style={{ zIndex: 0 }} />
          </Link>
        </div>
      </section>
      <Footer />
    </div>);

}